import useFilters from '../../../hook/useFilters'
import {dataToInquiriesPage, defaultColumns} from '../utils'
import {useAppSelector} from '../../../redux/useTypedSelector'
import {useLocation} from 'react-router-dom'
import useApi from '../../../services/useApi'

export default function useGetInquiresData() {
  const Api = useApi()
  const {user} = useAppSelector((state) => state.auth)
  const location = useLocation()
  const tab = location?.pathname?.split('/')?.pop() || ''
  const salesRepEmail = new URLSearchParams(location?.search)?.get('sales_rep') || ''
  const status = new URLSearchParams(location?.search)?.get('status') || ''
  const productSku = new URLSearchParams(location?.search)?.get('product') || null
  const purchaser = new URLSearchParams(location?.search)?.get('purchaser') || ''

  const {filters, setSingleFilter, setMultipleFilters} = useFilters({
    page: 1,
    limit: 20,
    filter: '',
    sort_by: 'date_submitted/-1',
    status: tab === 'archived' ? 'Archived' : status ?? '',
    rep_email: salesRepEmail ? salesRepEmail : `${user?.is_representative ? user?.username : ''}`,
    product_sku: productSku ?? null,
    purchaser: purchaser ?? null,
  })

  const {data, refetch, isFetching} = Api.useGetQuery(`/products/inquiries`, {
    filters: filters,
  })

  const onSearch = (searchValue: string) => {
    setSingleFilter('filter', searchValue)
  }

  const onPageChange = (page_number: number) => {
    setSingleFilter('page', page_number)
  }

  const onSortingChange = (key: string, value: string) => {
    const direction = value === 'asc' ? 1 : -1
    const sortFlag = key + '/' + direction

    setMultipleFilters({
      sort_by: sortFlag,
      page: 1,
    })
  }

  function onChangeCustomerFilter(email: string) {
    setMultipleFilters({
      rep_email: email,
    })
    // remove sales_rep search param from url
    const url = new URL(window?.location?.href)
    url?.searchParams?.delete('sales_rep')
    window?.history?.replaceState({}, '', url?.toString())
  }

  function onChangeStatusFilter(status: string) {
    setMultipleFilters({
      status: status,
    })
    // remove status search param from url
    const url = new URL(window?.location?.href)
    url?.searchParams?.delete('status')
    window?.history?.replaceState({}, '', url?.toString())
  }

  function onChangePurchaserFilter(email: string) {
    setMultipleFilters({
      purchaser: email,
    })
    // remove purchaser search param from url
    const url = new URL(window?.location?.href)
    url?.searchParams?.delete('purchaser')
    window?.history?.replaceState({}, '', url?.toString())
  }

  const onResetFilters = () => {
    setMultipleFilters({
      status: filters?.status === 'Archived' ? 'Archived' : '',
      rep_email: '',
      product_sku: null,
      purchaser: '',
    })
    // remove all search params from url
    const url = new URL(window?.location?.href)
    const paramsToDelete = Array.from(url.searchParams.keys())
    paramsToDelete.forEach((key) => url.searchParams.delete(key))
    window?.history?.replaceState({}, '', url?.toString())
  }

  const hasFilterApplied =
    (filters?.status !== '' && filters?.status !== 'Archived') ||
    filters?.rep_email !== '' ||
    filters?.product_sku !== null ||
    filters?.purchaser !== ''

  return {
    InquiresData: data?.data ? dataToInquiriesPage(data?.data) : [],
    columns: data?.['meta']?.['columns']?.length ? data?.['meta']?.['columns'] : defaultColumns,
    pagination: data?.['meta']?.['pagination'] || {},
    refetch,
    isLoading: isFetching,
    onPageChange,
    onSearch,
    onSortingChange,
    filters,
    onChangeCustomerFilter,
    onChangeStatusFilter,
    onChangePurchaserFilter,
    onResetFilters,
    hasFilterApplied,
  }
}
